import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import Icon from '../components/common/Icon';

const activities = [
  { icon: 'BookOpen', title: 'Formazione Politica', text: 'Scuola quadri, seminari, laboratori: strumenti per crescere come cittadini e dirigenti.', badge: 'Formazione' },
  { icon: 'Megaphone', title: 'Campagne Nazionali', text: 'Abitare Giovane, Scuola Libera, Lavoro Giusto: le nostre battaglie in tutta Italia.', badge: 'Campagne' },
  { icon: 'HandHeart', title: 'Volontariato', text: 'Iniziative di solidarietà, doposcuola, sportelli di ascolto, raccolta fondi.', badge: 'Sociale' },
  { icon: 'Vote', title: 'Partecipazione Democratica', text: 'Assemblee, congressi, consultazioni: la democrazia interna è il nostro metodo.', badge: 'Democrazia' },
  { icon: 'Leaf', title: 'Ambiente e Sostenibilità', text: "Azioni per il clima, pulizia urbana, sensibilizzazione ambientale.", badge: 'Ambiente' },
  { icon: 'Globe', title: 'Internazionale', text: "Scambi europei, YES, partecipazione a forum internazionali.", badge: 'Europa' },
];

const AttivitaPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Attività' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Cosa facciamo" title="Attività" subtitle="Dalla formazione politica al volontariato, dalle campagne nazionali alla partecipazione democratica." />
      <section className="section section--sm"><div className="container">
        <div className="grid grid-3">
          {activities.map((a) => (
            <div className="card" style={{ padding: 'var(--space-6)' }} key={a.title}>
              <div style={{ marginBottom: 'var(--space-3)', color: 'var(--color-primary)' }}><Icon name={a.icon} size={32} /></div>
              <span className="badge badge--subtle mb-3">{a.badge}</span>
              <h3 className="h4 mb-2">{a.title}</h3>
              <p className="text-body-sm text-secondary">{a.text}</p>
            </div>
          ))}
        </div>
      </div></section>
      <section className="section bg-subtle"><div className="container" style={{ textAlign: 'center' }}>
        <h2 className="h2 mb-4">Vuoi partecipare?</h2>
        <p className="text-body text-secondary mb-8" style={{ maxWidth: 500, marginInline: 'auto' }}>Trova il circolo più vicino e unisciti alle nostre attività.</p>
        <div className="btn-group" style={{ justifyContent: 'center' }}>
          <Link to="/circoli" className="btn btn--primary">Trova un circolo</Link>
          <Link to="/eventi" className="btn btn--outline">Prossimi eventi</Link>
        </div>
      </div></section>
    </Layout>
  );
};

export default AttivitaPage;
